import useSetChartExport from '@components/export/useSetChartExport';
import React from 'react';

function ExportTsRow({ data, rowData, filterIndex }) {
  const widgetKey = `timeseries-${rowData.id}-${filterIndex}`;

  useSetChartExport({
    pageKey: 'metriclens',
    sectionKey: 'ml-content',
    widgetKey,
    widgetInfo: {
      title: `Timeseries for F${filterIndex+1} on ${rowData.name}`,
    },
    data: data,
  })

  return <React.Fragment  key={widgetKey} />;
}

export default ExportTsRow;
